import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ButtonComp, CardComp } from "../../../components";
import InvestorPageShell from "../../../components/Investor/InvestorPageShell";
import { investorButtonProps } from "../../../components/Investor/investorButtonStyles";
import { useInvestorSession } from "../../../hooks/useInvestorSession";
import { getInvestorQueryParams, withInvestorQuery } from "../../../utils/investorRouteHelpers";

export default function InvestorOnboardingPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const preservedQuery = getInvestorQueryParams(searchParams);
  const { isMember, isKycApproved } = useInvestorSession();

  useEffect(() => {
    if (isKycApproved) {
      navigate(withInvestorQuery("/invest/dashboard", preservedQuery), { replace: true });
    }
  }, [isKycApproved, navigate, preservedQuery]);

  return (
    <InvestorPageShell
      title="Onboarding"
      subtitle={
        isMember
          ? "Complete verification to access investments."
          : "Complete your profile and identity verification."
      }
      backTo={null}
      narrow
    >
      <CardComp cardClassName="border-0 shadow-sm rounded-4">
        <p className="text-muted small mb-3">
          {isMember
            ? "You are signed in as a cooperative member. Complete KYC verification to explore investments."
            : "Update your profile and submit KYC verification to get started."}
        </p>
        <ButtonComp
          btnText="Continue to verification"
          onClick={() => navigate(withInvestorQuery("/invest/profile?tab=verification", preservedQuery))}
          {...investorButtonProps.primary}
          ButtonInlineStyle={{
            ...investorButtonProps.primary.ButtonInlineStyle,
            maxWidth: 280,
          }}
        />
      </CardComp>
    </InvestorPageShell>
  );
}
